export const toKebabCase = (value: string) => {
  return value.toLowerCase().replace(/\s/g, '-');
}

export const toSpaceCase = (value: string) => {
  return value.toLowerCase().replace(/[-_]/g, ' ');
}

export const escapeRegExp = (input: string): string => {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


export const createSlug = (input: string): string => {
  // get rid of accents (é etc)
  const removedDiacritic = input.normalize('NFD').replace(/\p{Diacritic}/gu, '');
  const value = removedDiacritic.replace(/&/g, 'and');

  return value
    .replace(/[\s/]+/g, '-')
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '');
};
